import { BaseEntity } from 'yt-ng-framework';

export class PlacanjeRacuna extends BaseEntity {
    constructor(){
        super();
    }

    Datum: Date=null;
    BrTrans: number=0;
    UkupnoDnevniPromet: number=0;
    UkupnoProvizija: number=0;

    Deserialize(input: any){
        this.ID=input.ID;
        this.Datum=input.Datum;
        this.BrTrans=input.BrTrans;
        this.UkupnoDnevniPromet=input.UkupnoDnevniPromet;
        this.UkupnoProvizija=input.UkupnoProvizija;

        return this;
    }

    Serialize(input: PlacanjeRacuna){
        return input;
    }

}